module.exports = __webpack_public_path__ + "img/5.85b9b3f3.png";